import React, { useState } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import ridaSubhan from '../../assets/Rehab staff/Ridha Subhan.JPG';
import anil from '../../assets/profile.png';

const teamMembers = [
  {
    name: 'D. Anil Kumar',
    role: 'Clinical Psychologist',
    bio: 'Passionate about helping individuals reach their potential.',
    image: anil,
  },
  {
    name: 'Rida Subhan',
    role: 'Behavioural Therapist',
    bio: 'Dedicated to improving lives through therapy.',
    image: ridaSubhan,
  },
];

const sections = [
  {
    title: 'Our Services',
    items: [
      { heading: 'Assessment and Evaluation', content: 'Our psychologists conduct thorough assessments to identify cognitive, emotional, and behavioral concerns, including neuropsychological evaluations, personality assessments, and behavioral observations.' },
      { heading: 'Individual Psychotherapy', content: 'We offer individualized psychotherapy sessions to address a range of mental health concerns, including anxiety, depression, trauma, grief, and adjustment disorders.' },
      { heading: 'Cognitive-Behavioral Therapy (CBT)', content: 'Our psychologists provide CBT to help individuals manage negative thought patterns, behaviors, and emotions.' },
      { heading: 'Mindfulness-Based Interventions', content: 'We offer mindfulness-based stress reduction and cognitive therapy to promote relaxation and emotional regulation.' },
      { heading: 'Family Therapy', content: 'Our psychologists work with families to improve relationship dynamics, communication, and coping skills.' },
      { heading: 'Group Therapy', content: 'We offer group sessions to enhance social support, skills development, and peer integration.' },
      { heading: 'Neuropsychological Rehabilitation', content: 'Specialized services to address cognitive and behavioral changes resulting from TBI, stroke, or dementia.' },
      { heading: 'Pain Management', content: 'Therapeutic interventions for managing chronic pain using CBT, relaxation techniques, and coping skills.' },
      { heading: 'Sleep Disorders Management', content: 'Interventions for insomnia, sleep apnea, and other sleep-related challenges.' },
      { heading: 'Teletherapy', content: 'Online therapy sessions for clients who prefer or require virtual access to care.' },
    ],
  },
  {
    title: 'Specialized Programs',
    items: [
      { heading: 'Trauma and Stress Management Program', content: 'Focused therapy for trauma, anxiety, and stress management using evidence-based approaches like trauma-focused CBT.' },
      { heading: 'Neuropsychology Program', content: 'Comprehensive neuropsychological assessments and rehab plans for neurological conditions.' },
      { heading: 'Pediatric Program', content: 'Therapeutic support for children facing emotional, behavioral, and developmental challenges.' },
      { heading: 'Geriatric Program', content: 'Supportive care for older adults, addressing cognitive decline, memory loss, and life transitions.' },
    ],
  },
];

const Psychology = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <div>

      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Psychology</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Psychology at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            We recognize the strong link between physical, emotional, and psychological health. Our psychology department offers evidence-based psychological assessments, therapies, and support services to address the unique mental health and rehabilitation needs of individuals across the lifespan.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.heading}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to delivering high-quality, evidence-based psychological care. Our goal is to empower individuals, enhance mental well-being, and support each client’s journey toward healing and personal growth.
            </p>
          </section>

          <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To know more about our <strong>Department of Psychology</strong>, or to schedule an appointment, click below and fill out our request form.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
      <Footer />
    </div>
  );
};

export default Psychology;
